// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1zl5_","content":"GlobalSearch_content__1GfoI"};